import React from "react";


const AdminDashboard = () => {
  
  return (
    <>
      <p>Selamat datang di dashboard admin</p>
    </>
  );
};

export default AdminDashboard;
